// extracted by mini-css-extract-plugin
export default {"btn":"ab","secondary":"bb","small":"cb","tiny":"db","blinking":"eb","gradientShift":"fb","float":"gb","move":"hb","scroll":"ib"};